
import { Hidden } from '@material-ui/core';
import { ThemeProvider } from '@material-ui/core/styles';
import { BsHeader, BsNavigator } from 'components';
import React from 'react';
// import PropTypes from 'prop-types';

import RenderRoutes from 'routes/RenderRoutes';
import { useUser } from 'store/user';
import theme from 'theme/backstageTheme';
import { useSetState } from 'utils/hooks/useSetState';
import { UiBsLayout, UiContent, UiDrawer } from './BsLayout.style';


/**
 * backstage layout
 */

const drawerWidth = 256;

export const BsLayout = ({ routes }) => {
  const [{ myOrganization }] = useUser();
  const [{ mobileOpen }, setState] = useSetState({ mobileOpen: false });

  const handleDrawerToggle = () => {
    setState({ mobileOpen: !mobileOpen });
  };

  return myOrganization.isLoaded && (
    <ThemeProvider theme={theme}>
      <UiBsLayout>
        <UiDrawer width={drawerWidth}>
          <Hidden smUp implementation="js">
            <BsNavigator
              PaperProps={{ style: { width: drawerWidth } }}
              variant="temporary"
              open={mobileOpen}
              onClose={handleDrawerToggle}
            />
          </Hidden>
          <Hidden xsDown implementation="css">
            <BsNavigator PaperProps={{ style: { width: drawerWidth } }} />
          </Hidden>
        </UiDrawer>
        <UiContent drawerWidth={drawerWidth}>
          <BsHeader onDrawerToggle={handleDrawerToggle} />
          <RenderRoutes routes={routes} />
        </UiContent>
      </UiBsLayout>
    </ThemeProvider>
  );
};

BsLayout.propTypes = {

};


